export default __webpack_public_path__ + "static/media/kouteki_meeting_calendar_icon.1388d96e.png";